import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import loginimg from "../images/logo.jpg";
import { getUserName } from "./Auth";
import Notificacoes from "./notificacaoes";
function Dashboard() {
  const navigate = useNavigate();

  const signOut = () => {
    localStorage.removeItem("Token");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("UserSecretariaId");
    localStorage.removeItem("UserId");
    localStorage.removeItem("UserName");
    window.location.reload();
    navigate("/");
  };
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const botao = document.querySelector(".botao-menu");
    const menuLateral = document.querySelector(".menu-lateral");
    const background = document.querySelector(".background");
    const dropdown = document.querySelector(".dropdown");
    const dropdownToggle = dropdown.querySelector(".dropdown-toggle");
    const token = localStorage.getItem("Token");
    setIsLoggedIn(!!token);
    const toggleMenu = (e) => {
      e.stopPropagation();
      botao.classList.toggle("ativo");
      menuLateral.classList.toggle("ativo");
      background.classList.toggle("ativo");
    };

    const closeMenu = (e) => {
      if (
        !e.target.closest(".menu-lateral") &&
        !e.target.closest(".botao-menu")
      ) {
        botao.classList.remove("ativo");
        menuLateral.classList.remove("ativo");
        background.classList.remove("ativo");
      }
    };

    const toggleDropdown = (e) => {
      e.stopPropagation();
      dropdown.classList.toggle("ativo");
    };

    botao.addEventListener("click", toggleMenu);
    document.addEventListener("click", closeMenu);
    dropdownToggle.addEventListener("click", toggleDropdown);

    return () => {
      botao.removeEventListener("click", toggleMenu);
      document.removeEventListener("click", closeMenu);
      dropdownToggle.removeEventListener("click", toggleDropdown);
    };
  }, []);

  return (
    <div>
      <button className="botao-menu" aria-label="Toggle menu">
        <i className="fa-solid fa-bars"></i>
      </button>

      <div className="principal">
        <nav className="menu-lateral">
          <div className="logologin">
            <img
              src={loginimg}
              alt="Logo Prefeitura de Guaratinguetá"
              className="loginimg"
            />
          </div>

          <ul>
            {/* Dropdown Processo */}
            <li className="side-item dropdown">
              <div className="dropdown-toggle">
                <i className="fa-solid fa-folder-open"></i>
                <span>Processo</span>
              </div>
              <ul className="dropdown-menu">
                <li>
                  <Link to="/">
                    <i className="fa-solid fa-hashtag"></i>
                    <span>Número</span>
                  </Link>
                </li>
                <li>
                  <Link to="/gantt2">
                    <i className="fa-solid fa-money-bill-wave"></i>
                    <span>Valor</span>
                  </Link>
                </li>
                <li>
                  <Link to="/graficobarra">
                    <i className="fa-solid fa-chart-bar"></i>
                    <span>Painel de Processos</span>
                  </Link>
                </li>
                <li className="side-item">
                  <Link to="/projetocompleto">
                    <i className="fa-solid fa-tasks"></i>
                    <span>Lista</span>
                  </Link>
                </li>
              </ul>
            </li>

            <li className="side-item">
              <Link to="/listapca">
                <i className="fa-solid fa-file-contract"></i>
                <span>PCA</span>
              </Link>
            </li>

            <li className="side-item">
              <Link to="/orcamento">
                <i className="fa-solid fa-usd"></i>
                <span>Orçamento</span>
              </Link>
            </li>

            <li className="side-item">
              <Link to="/projetosbairros">
                <i className="fa-solid fa-house-chimney-crack"></i>
                <span>Projetos por Bairros</span>
              </Link>
            </li>

            <li className="side-item">
              <Link to="/conveniosdade">
                <i className="fa-solid fa-handshake"></i>
                <span>Convênios</span>
              </Link>
            </li>
            {isLoggedIn && (
              <button type="button" className="button-sair" onClick={signOut}>
                <i className="fa-solid fa-sign-out-alt"></i>
                <span>Sair</span>
              </button>
            )}
            {!isLoggedIn && (
              <button
                type="button"
                className="button-sair"
                onClick={() => navigate("/login")}
              >
                <i className="fa-solid fa-sign-out-alt"></i>
                <span>Entrar</span>
              </button>
            )}
          </ul>
        </nav>

        <div className="background"></div>

        <div className="conteudo">
          <div
            className="titulo"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <h6
              className="m-0"
              style={{
                fontSize: "1.10rem",
                fontWeight: "bold",
                color: "#2c3e50",
                borderBottom: "3px solid rgb(106, 181, 232)",
                paddingBottom: "10px",
                margin: 0,
              }}
            >
              PREFEITURA MUNICIPAL DE GUARATINGUETÁ/SP - MÓDULO PROCESSOS
            </h6>
            {isLoggedIn && (
              <div
                style={{
                  position: "absolute",
                  right: "50px",
                  top: "45%",
                  transform: "translateY(-40%)",
                  whiteSpace: "nowrap",
                  fontWeight: "bold",
                  color: "#2c3e50",
                  borderBottom: "3px solid rgb(106, 181, 232)",
                }}
              >
                Olá {getUserName()}
                <Notificacoes />
              </div>
            )}
          </div>

          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
